import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "./UserContext/UserContext";

export default function AdminProtectedRoute({ children }) {
  const { user, loading } = useUser();

  if (loading) {
    return <div>Loading...</div>;
  }
  if (!user) {
    return <Navigate to="/admin" replace />;
  }
  if (!user.isAdmin) {
    return <Navigate to="/" replace />;
  }
  return children;
}
